import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

/** @jsx $jsx */
import { $jsx } from 'framework7';
import moment from 'moment';
import Base from '../js/base';
import Utils from '../js/utils';
export default (function (props, _ref) {
  var $ = _ref.$,
      $h = _ref.$h,
      $f7 = _ref.$f7,
      $update = _ref.$update,
      $tick = _ref.$tick;
  var page_name = 'update';
  var pn = "div[data-name=\"".concat(page_name, "\"]");
  var rows = null;
  var tong_co_so = 0,
      tong_he_thong = 0,
      tong_tra_hang = 0,
      tong_thuc_thu = 0,
      tong_balance = 0,
      tong_balance_color = '',
      tong_balance_sign = '';
  var date_format = moment().subtract(1, 'days').format(Base.dateFormat);
  var date_sql = moment().subtract(1, 'days').format('YYYY-MM-DD');

  var reset_stats = function reset_stats() {
    rows = null;
    tong_co_so = 0, tong_he_thong = 0, tong_tra_hang = 0, tong_thuc_thu = 0, tong_balance = 0, tong_balance_color = '', tong_balance_sign = '';
  }; //Lấy dữ liệu


  var get = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var ld, rs;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              ld = $f7.dialog.preloader('Đang tải dữ liệu');
              _context.next = 3;
              return Base.call({
                method: '_findAll',
                table: 'baocao_cuoingay',
                params: {
                  fields: 'baocao_cuoingay.*, branch.name',
                  join: 'JOIN branch ON branch.id = baocao_cuoingay.id_branch',
                  where: 'baocao_ngay=:date_sql',
                  where_data: {
                    date_sql: date_sql
                  },
                  order: 'name'
                }
              });

            case 3:
              rs = _context.sent;
              ld.close();

              if (!(rs.rows.length === 0)) {
                _context.next = 9;
                break;
              }

              reset_stats();
              $update(function () {
                $f7.dialog.alert('Chưa có dữ liệu ngày ' + date_format);
              });
              return _context.abrupt("return");

            case 9:
              rows = rs.rows.map(function (row) {
                row.balance_color = '';
                row.balance_sign = '';
                row.balance = false;
                var x = row.tong_tien * 1000,
                    y = row.kv_total,
                    z = row.kv_total_return ? row.kv_total_return : 0;
                var thuc_thu = y - z;
                row.thuc_thu = thuc_thu;
                row.balance = x - thuc_thu;

                if (x === thuc_thu) {
                  row.balance_color = '';
                  row.balance_sign = '';
                  row.balance = false;
                } else if (x > thuc_thu) {
                  row.balance_color = 'text-color-green';
                  row.balance_sign = '+';
                } else {
                  row.balance_color = 'text-color-red';
                  row.balance_sign = '';
                }

                tong_co_so += x;
                tong_he_thong += y;
                tong_tra_hang += z;
                tong_thuc_thu += thuc_thu;
                return row;
              });
              tong_balance = tong_co_so - tong_thuc_thu;

              if (tong_co_so === tong_thuc_thu) {
                tong_balance_color = '';
                tong_balance_sign = '';
                tong_balance = false;
              } else if (tong_co_so > tong_thuc_thu) {
                tong_balance_color = 'text-color-green';
                tong_balance_sign = '+';
              } else {
                tong_balance_color = 'text-color-red';
                tong_balance_sign = '';
              }

              $update();

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function get() {
      return _ref2.apply(this, arguments);
    };
  }();

  $tick(function () {
    get();
    $f7.calendar.create({
      dateFormat: 'dd/mm/yyyy',
      inputEl: $(pn + ' input[name="baocao_ngay"]'),
      closeOnSelect: true,
      on: {
        dayClick: function dayClick(cal, dayEl, y, m, d) {
          reset_stats();
          var selected_date = new Date(y, m, d);
          date_format = moment(selected_date).format(Base.dateFormat);
          date_sql = moment(selected_date).format('YYYY-MM-DD');
          get();
        }
      }
    });
  });

  var chitiet = function chitiet(e) {
    var id = parseInt($(e.target).data('id'));
    var loai = $(e.target).data('loai');
    var row = rows.find(function (row) {
      return row.id === id;
    });
    $f7.views.main.router.navigate('/baocao-eod-chitiet/', {
      props: {
        row: row,
        loai: loai
      }
    });
  };

  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div class="page" data-name="${page_name}" style="position:fixed">
  <div class="navbar" style="position:fixed">
    <div class="navbar-bg"></div>
    <div class="navbar-inner">
      <div class="left"><a href="#" data-panel=".panel-left" class="panel-open" id="menu-bars"><i class="f7-icons icon">bars</i></a></div>
      <div class="title sliding">Báo cáo cuối ngày</div>
      <div class="right"></div>
    </div>
  </div>
  <div class="page-content">
    <div class="list inline-labels">
      <ul>
        <li class="item-content item-input">
          <div class="item-inner">
            <div class="item-title item-label">Chọn ngày</div>
            <div class="item-input-wrap">
              <input type="text" name="baocao_ngay" value="${date_format}" />
            </div>
          </div>
        </li>
      </ul>
    </div>

    ${tong_co_so > 0 && $h`
      <div class="card data-table margin-half">
        <div class="card-header">Tổng chênh toàn hệ thống</div>
        <table>
          <thead>
            <tr>
              <th width="45%"></th>
              <th class="numeric-cell">Cơ sở báo</th>
              <th class="numeric-cell">Hệ thống</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td></td>
              <td class="${tong_balance_color} numeric-cell">${Utils.num2Str(tong_co_so)}</td>
              <td class="numeric-cell">${Utils.num2Str(tong_thuc_thu)}</td>
            </tr>
            ${tong_balance && $h`
              <tr class="${tong_balance_color}">
                <td>Lệch</td>
                <td class="numeric-cell">${tong_balance_sign}${Utils.num2Str(tong_balance)}</td>
                <td></td>
              </tr>
            `}
          </tbody>
        </table>
      </div>
    `}

    ${rows && rows.map(row=>$h`
      <div class="card data-table margin-half" key="${row.id}">
        <div class="card-header text-color-orange">${row.name}</div>
        <table>
          <thead>
            <tr>
              <th width="45%"></th>
              <th class="numeric-cell">Cơ sở báo</th>
              <th class="numeric-cell">Hệ thống</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>TỔNG</td>
              <td class="${row.balance_color} numeric-cell">${Utils.num2Str(row.tong_tien*1000)}</td>
              <td class="numeric-cell">
                ${row.kv_total_return > 0 && $h`
                  <div style="font-size:smaller">${Utils.num2Str(row.kv_total)}</div>
                  <div style="font-size:smaller">-${Utils.num2Str(row.kv_total_return)}</div>
                `}
                <div>${Utils.num2Str(row.thuc_thu)}</div>
              </td>
            </tr>
            ${row.balance && $h`
              <tr class="${row.balance_color}">
                <td>Lệch</td>
                <td class="numeric-cell">${row.balance_sign}${Utils.num2Str(row.balance)}</td>
                <td></td>
              </tr>
            `}
            <tr>
              <td>Tiền mặt</td>
              <td class="numeric-cell">${Utils.num2Str(row.tien_mat*1000)}</td>
              <td class="numeric-cell">${Utils.num2Str(row.kv_tien_mat)}</td>
            </tr>
            <tr>
              <td><a @click="${chitiet}" data-loai="chuyen_khoan" data-id="${row.id}">Chuyển khoản</a></td>
              <td class="numeric-cell">${Utils.num2Str(row.chuyen_khoan*1000)}</td>
              <td class="numeric-cell">${Utils.num2Str(row.kv_chuyen_khoan)}</td>
            </tr>
            <tr>
              <td><a @click="${chitiet}" data-loai="quet_the" data-id="${row.id}">Quẹt thẻ</a></td>
              <td class="numeric-cell">${Utils.num2Str(row.quet_the*1000)}</td>
              <td class="numeric-cell">${Utils.num2Str(row.kv_quet_the)}</td>
            </tr>
            <tr>
              <td><a @click="${chitiet}" data-loai="chi_phi" data-id="${row.id}">Chi</a></td>
              <td class="numeric-cell">${Utils.num2Str(row.chi_phi*1000)}</td>
              <td class="numeric-cell">-</td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td>Đổi điểm:</td>
              <td colspan="2">${Utils.num2Str(row.kv_diem)}</td>
            </tr>
            <tr>
              <td>Ghi chú:</td>
              <td colspan="2">
                <textarea style="width: 100%; height: 85px; font-size: 12px;" readonly>${row.note}</textarea>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    `)}
  </div>
</div>
`
    }
    ;
});